import React = require('react')

import { AccountingUtils } from '../common/accounting-utils'
import { CommonUtils } from '../common/common-utils'
import { getDataService } from '../common/data-service'
import { ExpenseSummaryItem } from '../common/expense-summary-calculator'
import { i18n } from '../common/i18n'
import { AccountingMenu } from './accounting-menu'
import { MainMenu } from './main-menu'
import { MonthSelection } from './month-selection'
import { Column, UiUtils } from './ui-utils'
import { User } from './user'
import { YearSelection } from './year-selection'

interface Row extends ExpenseSummaryItem {
  id: string,
}

interface ExpensesSummaryState {
  isLoading: boolean,
  year: string,
  month: string,
  summary: ExpenseSummaryItem[],
}

export class ExpensesSummary extends React.Component<Record<string, never>, ExpensesSummaryState> {
  state = {
    isLoading: true,
    year: CommonUtils.getCurrentYear(),
    month: CommonUtils.getCurrentMonth(),
    summary: null as ExpenseSummaryItem[] | null,
  }

  componentDidMount() {
    const period = this.getPeriod(this.state.year, this.state.month)
    getDataService().Expenses.summary(period.start, period.end)
    .then((summary) => {
      this.setState({
        isLoading: false,
        summary,
      })
    })
  }

  getLastDayOfMonth = (year, strMonth) => {
    const intMonth = parseInt(strMonth) - 1
    const newDate = new Date(Date.UTC(year, intMonth, 1, 0, 0, 0))
    return CommonUtils.getLastDayOfMonthYmd(newDate)
  }

  getPeriod = (year, month) => {
    if (month) {
      return {
        start: year + '-' + month + '-01',
        end: this.getLastDayOfMonth(year, month),
      }
    } else {
      return {
        start: year + '-01-01',
        end: year + '-12-31',
      }
    }
  }

  setPeriod = (year, month?) => {
    this.setState({ isLoading: true })
    const period = this.getPeriod(year, month)
    getDataService().Expenses.summary(period.start, period.end)
    .then((summary) => {
      this.setState({
        isLoading: false,
        year,
        month,
        summary,
      })
    })
  }

  setYear = (year) => {
    this.setPeriod(year)
  }

  setMonth = (month) => {
    const newMonth = month === this.state.month ? null : month
    this.setPeriod(this.state.year, newMonth)
  }

  getColumnConf = (): Column<Row>[] => {
    const lang = User.getLanguage()
    return [
      {
        id: 'id',
        header: i18n.t('common.category'),
        getCellContents: function(rowData) {
          return rowData.expenseCategory.paths[lang]
        },
      },
      {
        id: 'sum',
        header: i18n.t('common.amount'),
        getCellContents: function(rowData) {
          return CommonUtils.round(rowData.sum)
        },
      },
    ]
  }

  getRowsData = () => {
    return this.state.summary.map(function(sumElem): Row {
      const rowData = CommonUtils.clone(sumElem)
      return { ...rowData, id: rowData.expenseCategory._id }
    })
  }

  renderBody = () => {
    if (this.state.isLoading) {
      return <p>{i18n.t('common.loading')}</p>
    } else {
      const columnConf = this.getColumnConf()
      const rowsData = this.getRowsData()
      return UiUtils.getTable(columnConf, rowsData)
    }
  }

  render() {
    const { startYear } = AccountingUtils
    const currentYear = CommonUtils.getCurrentYear()
    return (
      <div>
        <MainMenu key="main" activeTab="accounting" />
        <AccountingMenu activeTab="expenses-summary" />
        <YearSelection
          start={startYear}
          end={currentYear}
          value={this.state.year}
          onChange={this.setYear}
        />
        <MonthSelection value={this.state.month} onChange={this.setMonth} />
        {this.renderBody()}
      </div>
    )
  }
}
